import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ScrollDirectiveSharedModule } from '@shared/core/directives/scroll/scroll.directive.shared.module';

import { DropDownComponent } from './drop-down.shared.component';
import { DropdownVendorComponent } from './dropdown-vendor.shared.component';
import { DropDownDirective } from './drop-down.shared.directive';
import { DropdDownOuterClickDirective } from './drop-down-outer-click.shared.directive';

const exportedComponents: any[] = [
    DropDownComponent,
    DropdownVendorComponent,
    DropDownDirective,
    DropdDownOuterClickDirective,
];

@NgModule({
    imports: [
        CommonModule,
        ScrollDirectiveSharedModule,
    ],
    declarations: [
        ...exportedComponents,
    ],
    entryComponents: [
        DropdownVendorComponent,
    ],
    exports: [
        ...exportedComponents,
    ],
    providers: [],
    schemas: []
})
export class DropDownModule { }
